import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Build one to throw away",
  "description": "",
  "published": "2019-06-19T00:00:00.000Z",
  "redirect_from": ["/blog/build-one-to-throw-away/swizec/9131"],
  "categories": "Learning, Personal",
  "hero": "./img/vUtVAWj.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "450px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/0ac643d40a5e60ad1009e2c6abd7973e/20e5d/vUtVAWj.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "133.18385650224215%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'533\\'%20viewBox=\\'0%200%20400%20533\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M291%201l19%201a2524%202524%200%200179%205c-1%201%200%201%201%201%202%200%202%200%201-1-3-1-1-2%204-2%204%200%205%200%205%202s-1%202-15%202c-16%200-19%200-18-2l-1-1-1%201-45%201h-45v3c0%204-1%206-3%204-2-1-2-2-1-3v-1l-3-2h-5c-7%200-22%204-23%205-1%202-5%203-11%203-3%200-4%200-3%201h2l-2%201c-3%202%206%203%2044%203l26%201v-5l1-5%206-1c9-1%209-1%209%206v5h19v-5l1-4%209-1%2010%201v16h-11v3l-1%2010v6h4c5%200%205%201%203%2014v6h-4l-4%201-1%208-1%2026c-1%2023-1%2022%201%2021%201%200%202%200%201%201-2%201-1%202%202%201l2%201%202%202c2%201%201%208-1%209-3%200-8-1-6-2v-2c-1-2-2%202-3%2014l1%2012%201-2%203-2c2%200%202%201%202%208l1%208%2020%205c1%201%207%202%2020%202l18%201v-2l-1-3v-8a5022%205022%200%20002-165l-1-3h-55c-36%200-55%200-54%201M1%2024v20h4c7%200%207-1%207%208%201%2012%200%2012-6%2012l-5%201%202%202v1c-2%200-2%202-2%2038l1%2037%2010%203%2016%204%205%202v-7l-1-22v-15l-6-4c-8-5-12-10-12-11l4%202%204%202h3l-2-3c-2-2-2-2%201-1l4%201c3%202%203%200%203-11-3-52-3-58-5-61l-4-3-4-3-5-4-2-2-3-3-3-1-2-1C1%205%201%205%201%2024m369-9l-1%208v7h3l4-1%203-1c7%200%208-1%208-7v-5h-6l-6-1h-5m-6%20148v12h2c1%201%201%200%201-2%200-4%200-4%201-2%200%203%201%203%204%203h3l1-8c0-8%200-9-7-9h-5v6M1%20163c0%204%200%204%203%205l4%201%202%201%2015%205c-1%200-1%201%201%202l2%205h-2l-3-2-2-1-2-2c-4-1-6%201-3%203l2%203v1l3%201%201-1v-1l3%204h-2c-2%200-2%200-1%201%201%202%201%202-1%204s-2%202-1%203v4c2%201%201%204-1%203l-3-1h-5c-1%202%202%203%203%202h2l3%205c3%202%203%203%202%204l-2%202-1%201v2h-2l-1%202c-1%202-1%202%201%204%201%202%201%202-1%204-2%203-2%203%200%204v2c1%202-3%201-5-1s-2-2-2%200H5c-2%200-2%200-2%202%200%201%201%202%204%202%209%200%2011%201%2014%203s3%202%201%202c-2%201-2%201-2%203%201%202%200%203-5%203-3%200-3%200-2%201%202%202%202%2010%201%2010l-4%202c-1%202-1%202%201%203%201%202%201%202-2%202-3%201-4%205-1%205l1%201%202%202c1%202%201%202-1%202-4%200-5%202-2%204l2%203%201%201c2%200%201%202-1%202-2%201-2%201-1%202%203%202%201%205-3%205-2%200-4%203-2%204v3l-3-2c-1-1-1-1-1%201l1%203c3%200%203%202%202%203v8c2%202%202%206-1%207-2%200-3%201-1%203v1l-1%2018%203%202c3%200%203%201%200%204-3%201-3%202-3%2012l1%2011v1l-1%205c0%205%200%206%203%208%202%202%202%205-1%206-2%200-2%202-2%2072v71h166v-52a3927%203927%200%20014-149c0%207%201%209%204%209%202%200%202%200%200-2-2-1-3-7%200-11%201-3%200-4-2-2%200%201-1%201-2-1v-3h-2l2-3c3%200%203%200%203-4l1-4c3%200%206-9%203-9l-7%201v-3h-2l1-1v-2c-1-2%200-4%202-5l1-8c1-6%201-6-2-6-3%201-3-1-3-22-1-26-2-29-7-29-3%200-8-5-9-9l-10-10-13-8c-8-5-28-13-44-18a851%20851%200%2000-82-21c-1-1-1%200-1%202m397%2027l-1%202v32l-1%2032c-2%200-2%201-2%204s0%204%202%204%202%208-1%208l-3%203-5%205-1%209c0%209%200%209%203%2011s3%203%203%207l1%205%201%2020c0%2017%200%2020%202%2020l1%2028%201%2028c2%200%202-11%202-88a1414%201414%200%2000-2-130m-45%20171l-5%201h-4l-8%202c-6%201-8%202-8%203l-1-1c-1-2-1-2-1%202%200%202%200%203%201%202l13-2a237%20237%200%200014-1h2l3-2v-2c-2-3-4-3-6-2m23%2054l4%201c4%200%204%200%204%202%200%203%200%203-4%203s-4%201-4%202c0%202-1%202-2%202l-2-1%201-1c3-2%200-3-5-2l-6%201-2%201-9%202-1%203c0%202%200%202%204%202h4l3-2c7-2%209-2%2012-1%203%200%204%203%201%203-2%201-2%2010%201%2010l1%207v6h-8v5c0%205%202%2011%204%2011l2-2c1-3%202-3%206-3h4v8h16v-56h-4l-4-1c0-2-2-2-8-2s-8%200-8%202m-32%2012h-2l-3%202h-4l-9%202c-2%200-3%201-3%203%200%201%200%202%203%201l5-1%205-1%205-1h1l1-1h1c2%201%204%200%204-3l-2-2-2%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0ac643d40a5e60ad1009e2c6abd7973e/ca0a1/vUtVAWj.webp 223w", "/static/0ac643d40a5e60ad1009e2c6abd7973e/75680/vUtVAWj.webp 445w", "/static/0ac643d40a5e60ad1009e2c6abd7973e/8626f/vUtVAWj.webp 450w"],
                "sizes": "(max-width: 450px) 100vw, 450px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0ac643d40a5e60ad1009e2c6abd7973e/853b2/vUtVAWj.jpg 223w", "/static/0ac643d40a5e60ad1009e2c6abd7973e/0a4fe/vUtVAWj.jpg 445w", "/static/0ac643d40a5e60ad1009e2c6abd7973e/20e5d/vUtVAWj.jpg 450w"],
                "sizes": "(max-width: 450px) 100vw, 450px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/0ac643d40a5e60ad1009e2c6abd7973e/20e5d/vUtVAWj.jpg",
                "alt": "The Mythical Man Month book chapter",
                "title": "The Mythical Man Month book chapter",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`The Mythical Man Month book chapter`}</figcaption>{`
  `}</figure></p>
    <p>{`On Mar 3rd, 2017 my favorite PM and I had a brilliant idea 👉 what if our chatbot could send text messages?`}</p>
    <p>{`We had recently launched a chatbot to our mobile app. Something to keep users busy while they wait for an operator. Ask introductory questions. Crack a couple jokes. Stall.`}</p>
    <p>{`This chatbot was flexible.`}</p>
    <p>{`You could make it say anything. One message, two messages, even simple logic sequences. Say a thing, present 2 buttons, continue based on response.`}</p>
    <p>{`It was lovely.`}</p>
    <p>{`But it wasn't getting enough traffic. People would click an ad, download the app, and never come back.`}</p>
    <p>{`You know how it is ... how many of the apps you download do you actually end up using? I know I don't.`}</p>
    <p>{`So we had these users, their phone numbers, their names, but we didn't have their attention.`}</p>
    <p>{`TEXT MESSAGES! You can text someone, if you have their number. Everyone opens a text message!`}</p>
    <p><img parentName="p" {...{
        "src": "/fde9b644accd60caea2c9173092a96ff/media-26BRBKqUiq586bRVm-giphy.gif",
        "alt": "brilliant giphy"
      }}></img></p>
    <h2 {...{
      "id": "a-marketing-automation-is-born"
    }}>{`A marketing automation is born`}</h2>
    <p>{`She, the PM, had an idea: Let's send text messages to re-engage our users. Remind them we exist. Get them coming back.`}</p>
    <p><em parentName="p">{`"Wait, you're gonna want to iterate on this aren't you ... play around, test things out"`}</em>{` 🤔`}</p>
    <p>{`Dunno, probably?`}</p>
    <p>{`Yeah I don't wanna write a bunch of code every time you change your mind ...`}</p>
    <p>{`THE CHATBOT!`}</p>
    <p>{`We can use the same chatbot scripts we've already got, follow the path with a background worker, send texts. It's just a directed graph, how hard can it be?`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "590px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/acbbce538e6400b56ca6ab9408c9732b/fcda8/Ch6vzYo.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "30.493273542600896%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'122\\'%20viewBox=\\'0%200%20400%20122\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M141%2031l-1%202c0%201-1%202-2%201-3%200-5%202-5%206s1%205%206%205h4v-7c0-6-1-9-2-7m-36%209c0%206%202%207%203%201%200-6%203-5%203%200%200%203%200%204%202%204l1-4c0-3%200-4%202-4l1%204c0%203%200%204%202%204%201%200%202-8%200-10l-8-1h-6v6m199-5c-3%204%200%2011%204%209l2%201c0%201-2%202-4%201h-3c0%202%205%203%208%202%202-2%202-3%202-8v-5l-4-1-5%201M38%2058v14l1%2012h13c12%200%2013-1%2013-3s0-2-4-2l-5-1c0-2%202-5%205-5l2-1h1l1-7c0-5%200-7-2-7-3-2-24-1-25%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/acbbce538e6400b56ca6ab9408c9732b/ca0a1/Ch6vzYo.webp 223w", "/static/acbbce538e6400b56ca6ab9408c9732b/75680/Ch6vzYo.webp 445w", "/static/acbbce538e6400b56ca6ab9408c9732b/5ca24/Ch6vzYo.webp 590w"],
              "sizes": "(max-width: 590px) 100vw, 590px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/acbbce538e6400b56ca6ab9408c9732b/e92b6/Ch6vzYo.png 223w", "/static/acbbce538e6400b56ca6ab9408c9732b/e66bf/Ch6vzYo.png 445w", "/static/acbbce538e6400b56ca6ab9408c9732b/fcda8/Ch6vzYo.png 590w"],
              "sizes": "(max-width: 590px) 100vw, 590px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/acbbce538e6400b56ca6ab9408c9732b/fcda8/Ch6vzYo.png",
              "alt": "Ch6vzYo",
              "title": "Ch6vzYo",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`And so the project I would spend the next two and a half years of my life working on was born. The text message marketing automation.`}</p>
    <p>{`That first version took about a week. It was pretty crude, but it served its purpose 👉 send a series of time-spaced text messages.`}</p>
    <p>{`As the months and years rolled by I would add things and fix bugs. Feature requests came in. Hey we want campaigns to last a few days. Sure. Hey we want to A/B test the cadence. Got it. Yo we wanna personalize the messages. You gots it. Hey why didn't that shit send? I have no idea let's make it inspectable. Hey what about branching logic based on behavior? err ... We want branching in the cadence too? uhhhh What about A/B testing and branching and personalization and having unique campaigns for each user and yo this damn app to write the scripts is way too complex and it never works and we are never quite certain that something did or didn't send and what is this pile of shite and for heaven's sake why does it take you engineers three weeks to add a new feature we need this stuff yesterday you are ruining all our marketing plans`}</p>
    <p><img parentName="p" {...{
        "src": "/405fa4e9ea6ddd7d012a62b029df363d/media-26n6HVkW3kwIEBjIQ-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`Whoa there. Chill dude`}</p>
    <p>{`The organization has outgrown the system. We were no longer able to keep up.`}</p>
    <p>{`Sure we added features and we made it more elegant and even invested a bunch of time into making it easier to extend and easier for other engineers to contribute. But our marketing automation was fundamentally becoming a product of its own.`}</p>
    <p>{`When you start thinking `}<em parentName="p">{`"I should just spin this out into its own startup"`}</em>{` you gotta ask yourself 👉 `}<em parentName="p">{`"Do I really want to spend the next 10 years dealing with this crap?"`}</em></p>
    <p>{`Hell to the no.`}</p>
    <h2 {...{
      "id": "throw-it-away"
    }}>{`Throw it away`}</h2>
    <p>{`You love what you've built. You are very proud. It has stood the test of time. It has made much money.`}</p>
    <p>{`Time to throw it away.`}</p>
    <p><img parentName="p" {...{
        "src": "/42fe32137855704d42fa76580c9365eb/media-l0HFkA6omUyjVYqw8-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`Marketing automation has come a long way since that fateful day in March 2017. Startups whose entire purpose in life it is to automate your marketing are everywhere.`}</p>
    <p>{`Search for "marketing automation" and you'll see. The landscape is vast and varied.`}</p>
    <p>{`Well maybe not varied.`}</p>
    <p>{`Everyone promises easy-to-use workflows, with a visual builder to boot, everyone has email, many have SMS too. Plenty that integrate directly with Facebook ads as well.`}</p>
    <p>{`It's quite astounding really.`}</p>
    <p>{`You could try to compete. Dig in your heels and scream `}<em parentName="p">{`"BUT MY JOB SECURITY"`}</em>{`. Yeah, if you own a business critical system at your company your job is pretty secure.`}</p>
    <p>{`You know what else happens?`}</p>
    <p>{`You don't have time to work on anything else. You won't get interesting projects. You won't get more responsibilities. You'll be stuck maintaining that damn system that you've built `}<em parentName="p">{`and`}</em>{` your company will be worse off for it.`}</p>
    <p>{`Throw that shit away.`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      